module.exports = __webpack_public_path__ + "assets/img/24870640c13f7783915df8c13a481b19.png";